import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var CFFHinting = /** @class */ (function (_super) {
    __extends(CFFHinting, _super);
    function CFFHinting() {
        var _this = _super.call(this) || this;
        console.warn('[CFFHinting] not implemented');
        return _this;
    }
    CFFHinting.forceNativeConstructor = true;
    CFFHinting.forceNativeMethods = true;
    CFFHinting.NONE = 'none';
    CFFHinting.HORIZONTAL_STEM = 'horizontalStem';
    return CFFHinting;
}(ASObject));
export { CFFHinting };
